// tslint:disable: variable-name
import { OrgaoAudesp } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Licitacao } from './licitacao.model';
import { MemorialAdesao } from './memorial-adesao.model';

export class LicitacaoOrgaoAudesp extends BaseResourceModel {
  constructor(
    public id?: number,
    public orgao_audesp?: OrgaoAudesp,
    public licitacao?: Licitacao,
    public orgao_aderente?: boolean,
    public itens_adesao?: MemorialAdesao[]
  ) {
    super();
  }

  static converteJson(json: any): LicitacaoOrgaoAudesp {
    return Object.assign(new LicitacaoOrgaoAudesp(), json);
  }
}
